import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@trinity/chat-components/query-keys/index.js';

export const useInvalidateQuantFolders = () => {
  const queryClient = useQueryClient();

  return useCallback((quantAnalysisId: number, projectId: number, versionId?: number) => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.projects.quantAnalysis.directoryTree({ projectId, quantAnalysisId, versionId }),
    });
  }, [queryClient]);
};